import { Box, CircularProgress } from '@mui/material';
import { DEFAULT_USERS_COLUMNS } from 'common/constants/reports';
import { ReportCustomTableColumn, ReportProductEntitlements, User } from 'features/reports/typeDefs';

import { ReportContentWrapper } from './ReportContentWrapper';
import { ReportCustomTable } from './ReportCustomTable';


const processingLoader = (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress color='primary'/>
    </Box>
);

type ReportModalContentProps = {
    entitlementsColumns: ReportCustomTableColumn[];
    entitlementsRows: ReportProductEntitlements[];
    usersColumns?: ReportCustomTableColumn[];
    usersRows: User[];
    processingProductEntitlementsFetch: boolean;
    processingUsersFetch: boolean;
}

export const ReportModalContent = ({ entitlementsColumns, entitlementsRows, usersColumns, usersRows, processingProductEntitlementsFetch, processingUsersFetch }: ReportModalContentProps) => {
    return (processingProductEntitlementsFetch || processingUsersFetch) ? processingLoader :
        (
            <ReportContentWrapper>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <ReportCustomTable
                        dataTestId='product-entitlements-id'
                        columns={entitlementsColumns}
                        rows={entitlementsRows}
                        tableCaption='Product Entitlements'
                        countMessage={`Number of entitlements: ${entitlementsRows.length}`}
                    />
                    <ReportCustomTable
                        dataTestId='users-id'
                        columns={usersColumns ?? DEFAULT_USERS_COLUMNS}
                        rows={usersRows}
                        tableCaption='Users'
                        countMessage={`Number of users: ${usersRows.length}`}
                    />
                </div>
            </ReportContentWrapper>
        );
};
